import apiKeyCloak from "../services/api-keycloak";

const RESOURCE = "";

export const Authenticate = {
  SignInRequest: async ({ username, password }) => {
    const urlencoded = new URLSearchParams({
      username: username,
      password: password,
      grant_type: process.env.REACT_APP_GRAND_TYPE ?? "",
      client_id: process.env.REACT_APP_CLIENT_ID ?? "",
      client_secret: process.env.REACT_APP_CLIENT_SECRET ?? "",
    });

    return await apiKeyCloak.post(RESOURCE, urlencoded);
  },
};
